import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col, Skeleton } from 'modules/Core/Common';

import * as S from './AnswersHeader.styles';

export const AnswersHeaderPlaceholder = ({ hasDeviceInfo = false }) => {
  return (
    <S.Container>
      <S.ExerciseInfo>
        <Row style={{ width: '100%', margin: 0 }}>
          <Col xs={12} xl={4}>
            <S.User>
              <S.LoadingContainer>
                <Skeleton type="round" />
                <div style={{ marginLeft: '1.6rem' }}>
                  <Skeleton type="medium" />
                  <Skeleton type="string" style={{ width: '75%' }} />
                </div>
              </S.LoadingContainer>
            </S.User>
          </Col>
          <Col xs={12} xl={8} style={{ padding: 0 }}>
            <S.Information style={{ height: '100%' }}>
              <S.LoadingContainer secondary>
                <S.Item style={{ borderLeft: 'none' }}>
                  <Skeleton type="string" style={{ width: '25%' }} />
                  <Skeleton type="string" style={{ width: '50%' }} />
                </S.Item>
              </S.LoadingContainer>
            </S.Information>
          </Col>
        </Row>
      </S.ExerciseInfo>
      {hasDeviceInfo && (
        <S.ScoresDevice>
          <Row style={{ width: '100%', margin: 0 }}>
            <Col xs={12} xl={4} style={{ paddingRight: 0 }}>
              <S.Title>
                <S.LoadingContainer>
                  <Skeleton type="round" />
                  <div style={{ marginLeft: '1.6rem' }}>
                    <Skeleton type="string" style={{ width: '75%' }} />
                  </div>
                </S.LoadingContainer>
              </S.Title>
            </Col>
            <Col xs={12} xl={8}>
              <S.DeviceDetails>
                <li>
                  <S.LoadingContainer style={{ width: '10rem' }}>
                    <Skeleton type="string" style={{ width: '75%' }} />
                  </S.LoadingContainer>
                </li>
                <li>
                  <S.LoadingContainer style={{ width: '10rem' }}>
                    <Skeleton type="string" style={{ width: '75%' }} />
                  </S.LoadingContainer>
                </li>
                <li>
                  <S.LoadingContainer style={{ width: '10rem' }}>
                    <Skeleton type="string" style={{ width: '75%' }} />
                  </S.LoadingContainer>
                </li>
                <li>
                  <S.LoadingContainer style={{ width: '10rem' }}>
                    <Skeleton type="string" style={{ width: '75%' }} />
                  </S.LoadingContainer>
                </li>
              </S.DeviceDetails>
            </Col>
          </Row>
        </S.ScoresDevice>
      )}
    </S.Container>
  );
};

AnswersHeaderPlaceholder.propTypes = {
  hasDeviceInfo: PropTypes.bool,
};
